import {
  ACDTYPE_TEXT,
  ACDTYPE_TEXT_ONLY,
  ACDTYPE_IMAGE,
  ACDTYPE_VIDEO,
  ACDTYPE_AUDIO,
  ACDTYPE_SEPARATOR,
  ACDTYPE_IMAGE_ONLY,
  ACDTYPE_IMAGE_ARR
} from "./ACDTypes";

import {
  ACSTYPE_TITLE,
  ACSTYPE_PARAGRAPH,
  ACSTYPE_IMAGE,
  ACSTYPE_MAIN_IMG,
  ACSTYPE_VIDEO,
  ACSTYPE_AUDIO,
  ACSTYPE_GALLERY
} from "./ACSTypes";

import { generateUniqueID } from "../utils/utils";

/*****************
	
	TEXT Item / TEXT ONLY Item

	{
		id: id,
	    text: "",
	    isTextServerProcessed: true,
	    textLineIDs: null,
	    dataType: ACDTYPE_TEXT,
	    styleType: "SECTION_TITLE",
	    names: [
        	{ type: "", name: ["", "", ""] },
        	{ type: "", name: "" },
        	{ type: "", name: "" }
      	]
	}

	=====

	SEPARATOR Item

	{
		id: id,
		dataType: ACDTYPE_SEPARATOR,
	}

*******************/

export function mergeTextItemWith(textItem, anotherItem, reversed) {
  let newStyleType = "";
  let newText = "";
  let newID = "";
  let newDataItem = {};
  let newNames = null;

  switch (anotherItem.dataType) {
    case ACDTYPE_TEXT:
      newStyleType = ACSTYPE_PARAGRAPH;
      newText = "";
      newID = generateUniqueID();

      if (!reversed) {
        newStyleType =
          anotherItem.styleType == null ? newStyleType : anotherItem.styleType;
        newStyleType =
          textItem.styleType == null ? newStyleType : textItem.styleType;
        newText = textItem.text + anotherItem.text;

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = textItem.id == null ? newID : textItem.id;

        newNames = anotherItem.names == null ? newNames : anotherItem.names;
        newNames = textItem.names == null ? newNames : textItem.names;
      } else {
        newStyleType =
          textItem.styleType == null ? newStyleType : textItem.styleType;
        newStyleType =
          anotherItem.styleType == null ? newStyleType : anotherItem.styleType;
        newText = anotherItem.text + textItem.text;

        newID = textItem.id == null ? newID : textItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        newNames = textItem.names == null ? newNames : textItem.names;
        newNames = anotherItem.names == null ? newNames : anotherItem.names;
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed:
          (textItem.textLineIDs == null || anotherItem.textLineIDs == null) &&
          textItem.isTextServerProcessed &&
          anotherItem.isTextServerProcessed,
        textLineIDs: combineTextLineIDs(
          textItem.textLineIDs,
          anotherItem.textLineIDs
        ),
        dataType: ACDTYPE_TEXT,
        styleType: newStyleType,
        names: newNames
      };

      return newDataItem;
    case ACDTYPE_TEXT_ONLY:
      newStyleType = ACSTYPE_TITLE;
      newText = "";
      newID = generateUniqueID();

      newStyleType =
        anotherItem.styleType == null ? newStyleType : anotherItem.styleType;

      if (!reversed) {
        newText = textItem.text + anotherItem.text;

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = textItem.id == null ? newID : textItem.id;

        newNames = anotherItem.names == null ? newNames : anotherItem.names;
        newNames = textItem.names == null ? newNames : textItem.names;
      } else {
        newText = anotherItem.text + textItem.text;

        newID = textItem.id == null ? newID : textItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        newNames = textItem.names == null ? newNames : textItem.names;
        newNames = anotherItem.names == null ? newNames : anotherItem.names;
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed:
          (textItem.textLineIDs == null || anotherItem.textLineIDs == null) &&
          textItem.isTextServerProcessed &&
          anotherItem.isTextServerProcessed,
        textLineIDs: combineTextLineIDs(
          textItem.textLineIDs,
          anotherItem.textLineIDs
        ),
        dataType: ACDTYPE_TEXT_ONLY,
        styleType: newStyleType,
        names: newNames
      };

      return newDataItem;
    case ACDTYPE_IMAGE:
      newStyleType = ACSTYPE_IMAGE;
      newText = "";
      newID = generateUniqueID();

      newStyleType =
        anotherItem.styleType == null ? newStyleType : anotherItem.styleType;

      if (!reversed) {
        newText = textItem.text + anotherItem.text;

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = textItem.id == null ? newID : textItem.id;

        newNames = anotherItem.names == null ? newNames : anotherItem.names;
        newNames = textItem.names == null ? newNames : textItem.names;
      } else {
        newText = anotherItem.text + textItem.text;

        newID = textItem.id == null ? newID : textItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        newNames = textItem.names == null ? newNames : textItem.names;
        newNames = anotherItem.names == null ? newNames : anotherItem.names;
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed:
          (textItem.textLineIDs == null || anotherItem.textLineIDs == null) &&
          textItem.isTextServerProcessed &&
          anotherItem.isTextServerProcessed,
        textLineIDs: combineTextLineIDs(
          textItem.textLineIDs,
          anotherItem.textLineIDs
        ),
        image: anotherItem.image,
        dataType: ACDTYPE_IMAGE,
        styleType: newStyleType,
        names: newNames
      };

      return newDataItem;

    case ACDTYPE_VIDEO:
      newStyleType = ACSTYPE_VIDEO;
      newText = "";
      newID = generateUniqueID();

      newStyleType =
        anotherItem.styleType == null ? newStyleType : anotherItem.styleType;

      if (!reversed) {
        newText = textItem.text + anotherItem.text;

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = textItem.id == null ? newID : textItem.id;

        newNames = anotherItem.names == null ? newNames : anotherItem.names;
        newNames = textItem.names == null ? newNames : textItem.names;
      } else {
        newText = anotherItem.text + textItem.text;

        newID = textItem.id == null ? newID : textItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        newNames = textItem.names == null ? newNames : textItem.names;
        newNames = anotherItem.names == null ? newNames : anotherItem.names;
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed:
          (textItem.textLineIDs == null || anotherItem.textLineIDs == null) &&
          textItem.isTextServerProcessed &&
          anotherItem.isTextServerProcessed,
        textLineIDs: combineTextLineIDs(
          textItem.textLineIDs,
          anotherItem.textLineIDs
        ),
        image: anotherItem.image,
        media: anotherItem.media,
        dataType: ACDTYPE_VIDEO,
        styleType: newStyleType,
        names: newNames
      };

      return newDataItem;

    case ACDTYPE_AUDIO:
      newStyleType = ACSTYPE_AUDIO;
      newText = "";
      newID = generateUniqueID();

      newStyleType =
        anotherItem.styleType == null ? newStyleType : anotherItem.styleType;

      if (!reversed) {
        newText = textItem.text + anotherItem.text;

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = textItem.id == null ? newID : textItem.id;

        newNames = anotherItem.names == null ? newNames : anotherItem.names;
        newNames = textItem.names == null ? newNames : textItem.names;
      } else {
        newText = anotherItem.text + textItem.text;

        newID = textItem.id == null ? newID : textItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        newNames = textItem.names == null ? newNames : textItem.names;
        newNames = anotherItem.names == null ? newNames : anotherItem.names;
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed:
          (textItem.textLineIDs == null || anotherItem.textLineIDs == null) &&
          textItem.isTextServerProcessed &&
          anotherItem.isTextServerProcessed,
        textLineIDs: combineTextLineIDs(
          textItem.textLineIDs,
          anotherItem.textLineIDs
        ),
        image: anotherItem.image,
        media: anotherItem.media,
        dataType: ACDTYPE_AUDIO,
        styleType: newStyleType,
        names: newNames
      };

      return newDataItem;

    case ACDTYPE_SEPARATOR:
      return null;
    case ACDTYPE_IMAGE_ONLY:
      return null;
    case ACDTYPE_IMAGE_ARR:
      newStyleType = ACSTYPE_GALLERY;
      newText = "";
      newID = generateUniqueID();

      newStyleType =
        anotherItem.styleType == null ? newStyleType : anotherItem.styleType;

      if (!reversed) {
        newText = textItem.text + anotherItem.text;

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = textItem.id == null ? newID : textItem.id;

        newNames = anotherItem.names == null ? newNames : anotherItem.names;
        newNames = textItem.names == null ? newNames : textItem.names;
      } else {
        newText = anotherItem.text + textItem.text;

        newID = textItem.id == null ? newID : textItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        newNames = textItem.names == null ? newNames : textItem.names;
        newNames = anotherItem.names == null ? newNames : anotherItem.names;
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed:
          (textItem.textLineIDs == null || anotherItem.textLineIDs == null) &&
          textItem.isTextServerProcessed &&
          anotherItem.isTextServerProcessed,
        textLineIDs: combineTextLineIDs(
          textItem.textLineIDs,
          anotherItem.textLineIDs
        ),
        imageItemArr: anotherItem.imageItemArr,
        dataType: ACDTYPE_IMAGE_ARR,
        styleType: newStyleType,
        names: newNames
      };

      return newDataItem;
    default:
      throw Error("unknown data type");
  }
}

export function combineTextLineIDs(inputTextLineIDs, anotherInputTextLineIDs) {
  let combinedTextLineIDs = null;

  if (inputTextLineIDs != null && anotherInputTextLineIDs != null) {
    combinedTextLineIDs = {};

    const fromPageIDArr = Object.keys(inputTextLineIDs);
    const toPageIDArr = Object.keys(anotherInputTextLineIDs);

    const newPageIDArr = Array.from(new Set(fromPageIDArr.concat(toPageIDArr)));

    let i;
    for (i = 0; i < newPageIDArr.length; i++) {
      const pageID = newPageIDArr[i];

      const fromTextPageData = inputTextLineIDs[pageID];
      const toTextPageData = anotherInputTextLineIDs[pageID];

      const fromTextLineIndexes =
        fromTextPageData == null ? null : fromTextPageData.textLineIndexes;
      const toTextLineIndexes =
        toTextPageData == null ? null : toTextPageData.textLineIndexes;

      let combinedLineIndexes = null;

      if (fromTextLineIndexes != null && toTextLineIndexes != null) {
        combinedLineIndexes = Array.from(
          new Set(fromTextLineIndexes.concat(toTextLineIndexes))
        ).sort();
      } else if (fromTextLineIndexes != null) {
        combinedLineIndexes = fromTextLineIndexes;
      } else if (toTextLineIndexes != null) {
        combinedLineIndexes = toTextLineIndexes;
      }

      const data = {
        pageID: pageID,
        textLineIndexes: combinedLineIndexes
      };

      combinedTextLineIDs[pageID] = data;
    }
  } else if (inputTextLineIDs != null) {
    combinedTextLineIDs = inputTextLineIDs;
  } else if (anotherInputTextLineIDs != null) {
    combinedTextLineIDs = anotherInputTextLineIDs;
  }

  return combinedTextLineIDs;
}

export function mergeTextOnlyItemWith(textOnlyItem, anotherItem, reversed) {
  let newStyleType = "";
  let newText = "";
  let newID = "";
  let newDataItem = {};
  let newNames = null;

  switch (anotherItem.dataType) {
    case ACDTYPE_TEXT:
      throw Error("this order should not happen");
    case ACDTYPE_TEXT_ONLY:
      newStyleType = ACSTYPE_TITLE;
      newText = "";
      newID = generateUniqueID();

      if (!reversed) {
        newStyleType =
          anotherItem.styleType == null ? newStyleType : anotherItem.styleType;
        newStyleType =
          textOnlyItem.styleType == null
            ? newStyleType
            : textOnlyItem.styleType;
        newText = textOnlyItem.text + anotherItem.text;

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = textOnlyItem.id == null ? newID : textOnlyItem.id;

        newNames = anotherItem.names == null ? newNames : anotherItem.names;
        newNames = textOnlyItem.names == null ? newNames : textOnlyItem.names;
      } else {
        newStyleType =
          textOnlyItem.styleType == null
            ? newStyleType
            : textOnlyItem.styleType;
        newStyleType =
          anotherItem.styleType == null ? newStyleType : anotherItem.styleType;
        newText = anotherItem.text + textOnlyItem.text;

        newID = textOnlyItem.id == null ? newID : textOnlyItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        newNames = textOnlyItem.names == null ? newNames : textOnlyItem.names;
        newNames = anotherItem.names == null ? newNames : anotherItem.names;
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed:
          (textOnlyItem.textLineIDs == null ||
            anotherItem.textLineIDs == null) &&
          textOnlyItem.isTextServerProcessed &&
          anotherItem.isTextServerProcessed,
        textLineIDs: combineTextLineIDs(
          textOnlyItem.textLineIDs,
          anotherItem.textLineIDs
        ),
        dataType: ACDTYPE_TEXT_ONLY,
        styleType: newStyleType,
        names: newNames
      };

      return newDataItem;
    case ACDTYPE_IMAGE:
      return null;
    case ACDTYPE_VIDEO:
      return null;
    case ACDTYPE_AUDIO:
      return null;
    case ACDTYPE_SEPARATOR:
      return null;
    case ACDTYPE_IMAGE_ONLY:
      return null;
    case ACDTYPE_IMAGE_ARR:
      return null;
    default:
      throw Error("unknown data type");
  }
}

export function mergeImageWith(imageItem, anotherItem, reversed) {
  let newStyleType = "";
  let newText = "";
  let newID = "";
  let newDataItem = {};
  let newNames = null;
  let newImage = null;
  let images = [];

  switch (anotherItem.dataType) {
    case ACDTYPE_TEXT:
      throw Error("this order should not happen");
    case ACDTYPE_TEXT_ONLY:
      throw Error("this order should not happen");
    case ACDTYPE_IMAGE:
      newStyleType = ACSTYPE_GALLERY;
      newText = "";
      newID = generateUniqueID();
      images = [];

      if (!reversed) {
        images = [imageItem, anotherItem];

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = imageItem.id == null ? newID : imageItem.id;
      } else {
        images = [anotherItem, imageItem];

        newID = imageItem.id == null ? newID : imageItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;
      }

      if (imageItem.id == null) {
        imageItem.id = generateUniqueID();
      }

      if (anotherItem.id == null) {
        anotherItem.id = generateUniqueID();
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed: true,
        textLineIDs: null,
        dataType: ACDTYPE_IMAGE_ARR,
        styleType: newStyleType,
        names: newNames,
        imageItemArr: images
      };

      return newDataItem;

    case ACDTYPE_VIDEO:
      newStyleType = ACSTYPE_GALLERY;
      newText = "";
      newID = generateUniqueID();
      images = [];

      if (!reversed) {
        images = [imageItem, anotherItem];

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = imageItem.id == null ? newID : imageItem.id;
      } else {
        images = [anotherItem, imageItem];

        newID = imageItem.id == null ? newID : imageItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;
      }

      if (imageItem.id == null) {
        imageItem.id = generateUniqueID();
      }

      if (anotherItem.id == null) {
        anotherItem.id = generateUniqueID();
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed: true,
        textLineIDs: null,
        dataType: ACDTYPE_IMAGE_ARR,
        styleType: newStyleType,
        names: newNames,
        imageItemArr: images
      };

      return newDataItem;
    case ACDTYPE_AUDIO:
      return null;
    case ACDTYPE_SEPARATOR:
      return null;
    case ACDTYPE_IMAGE_ONLY:
      newStyleType = ACSTYPE_MAIN_IMG;
      newText = "";
      newID = generateUniqueID();

      if (!reversed) {
        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = imageItem.id == null ? newID : imageItem.id;

        newImage = anotherItem.image;
      } else {
        newID = imageItem.id == null ? newID : imageItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        newImage = imageItem.image;
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed: true,
        textLineIDs: null,
        image: newImage,
        dataType: ACDTYPE_IMAGE_ONLY,
        styleType: newStyleType,
        names: newNames
      };

      return newDataItem;

    case ACDTYPE_IMAGE_ARR:
      newStyleType = anotherItem.styleType;
      newText = anotherItem.text;

      newID = generateUniqueID();

      if (!reversed) {
        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = imageItem.id == null ? newID : imageItem.id;

        images = [imageItem, ...anotherItem.imageItemArr];
      } else {
        newID = imageItem.id == null ? newID : imageItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        images = [...anotherItem.imageItemArr, imageItem];
      }

      if (imageItem.id == null) {
        imageItem.id = generateUniqueID();
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed: true,
        textLineIDs: anotherItem.textLineIDs,
        dataType: ACDTYPE_IMAGE_ARR,
        styleType: newStyleType,
        names: newNames,
        imageItemArr: images
      };

      return newDataItem;

    default:
      throw Error("unknown data type");
  }
}

export function mergeVideoWith(videoItem, anotherItem, reversed) {
  let newStyleType = "";
  let newText = "";
  let newID = "";
  let newDataItem = {};
  let newNames = null;
  let images = [];

  switch (anotherItem.dataType) {
    case ACDTYPE_TEXT:
      throw Error("this order should not happen");
    case ACDTYPE_TEXT_ONLY:
      throw Error("this order should not happen");
    case ACDTYPE_IMAGE:
      throw Error("this order should not happen");
    case ACDTYPE_VIDEO:
      newStyleType = ACSTYPE_GALLERY;
      newText = "";
      newID = generateUniqueID();
      images = [];

      if (!reversed) {
        images = [videoItem, anotherItem];

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = videoItem.id == null ? newID : videoItem.id;
      } else {
        images = [anotherItem, videoItem];

        newID = videoItem.id == null ? newID : videoItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;
      }

      if (videoItem.id == null) {
        videoItem.id = generateUniqueID();
      }

      if (anotherItem.id == null) {
        anotherItem.id = generateUniqueID();
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed: true,
        textLineIDs: null,
        dataType: ACDTYPE_IMAGE_ARR,
        styleType: newStyleType,
        names: newNames,
        imageItemArr: images
      };

      return newDataItem;
    case ACDTYPE_AUDIO:
      return null;
    case ACDTYPE_SEPARATOR:
      return null;
    case ACDTYPE_IMAGE_ONLY:
      return null;
    case ACDTYPE_IMAGE_ARR:
      newStyleType = anotherItem.styleType;
      newText = anotherItem.text;

      newID = generateUniqueID();

      if (!reversed) {
        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = videoItem.id == null ? newID : videoItem.id;

        images = [videoItem, ...anotherItem.imageItemArr];
      } else {
        newID = videoItem.id == null ? newID : videoItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        images = [...anotherItem.imageItemArr, videoItem];
      }

      if (videoItem.id == null) {
        videoItem.id = generateUniqueID();
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed: true,
        textLineIDs: anotherItem.textLineIDs,
        dataType: ACDTYPE_IMAGE_ARR,
        styleType: newStyleType,
        names: newNames,
        imageItemArr: images
      };

      return newDataItem;
    default:
      throw Error("unknown data type");
  }
}

export function mergeAudioWith(audioItem, anotherItem, reversed) {
  switch (anotherItem.dataType) {
    case ACDTYPE_TEXT:
      throw Error("this order should not happen");
    case ACDTYPE_TEXT_ONLY:
      throw Error("this order should not happen");
    case ACDTYPE_IMAGE:
      throw Error("this order should not happen");
    case ACDTYPE_VIDEO:
      throw Error("this order should not happen");
    case ACDTYPE_AUDIO:
      return null;
    case ACDTYPE_SEPARATOR:
      return null;
    case ACDTYPE_IMAGE_ONLY:
      return null;
    case ACDTYPE_IMAGE_ARR:
      return null;
    default:
      throw Error("unknown data type");
  }
}

export function mergeSepWith(sepItem, anotherItem, reversed) {
  switch (anotherItem.dataType) {
    case ACDTYPE_TEXT:
      throw Error("this order should not happen");
    case ACDTYPE_TEXT_ONLY:
      throw Error("this order should not happen");
    case ACDTYPE_IMAGE:
      throw Error("this order should not happen");
    case ACDTYPE_VIDEO:
      throw Error("this order should not happen");
    case ACDTYPE_AUDIO:
      throw Error("this order should not happen");
    case ACDTYPE_SEPARATOR:
      return null;
    case ACDTYPE_IMAGE_ONLY:
      return null;
    case ACDTYPE_IMAGE_ARR:
      return null;
    default:
      throw Error("unknown data type");
  }
}

export function mergeImageOnlyItemWith(imageOnlyItem, anotherItem, reversed) {
  let newStyleType = "";
  let newText = "";
  let newID = "";
  let newDataItem = {};
  let newNames = null;
  let newImage = null;

  switch (anotherItem.dataType) {
    case ACDTYPE_TEXT:
      throw Error("this order should not happen");
    case ACDTYPE_TEXT_ONLY:
      throw Error("this order should not happen");
    case ACDTYPE_IMAGE:
      throw Error("this order should not happen");
    case ACDTYPE_VIDEO:
      throw Error("this order should not happen");
    case ACDTYPE_AUDIO:
      throw Error("this order should not happen");
    case ACDTYPE_SEPARATOR:
      throw Error("this order should not happen");
    case ACDTYPE_IMAGE_ONLY:
      newStyleType = ACSTYPE_MAIN_IMG;
      newText = "";
      newID = generateUniqueID();

      if (!reversed) {
        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = imageOnlyItem.id == null ? newID : imageOnlyItem.id;

        newImage = anotherItem.image;
      } else {
        newID = imageOnlyItem.id == null ? newID : imageOnlyItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        newImage = imageOnlyItem.image;
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed: true,
        textLineIDs: null,
        image: newImage,
        dataType: ACDTYPE_IMAGE_ONLY,
        styleType: newStyleType,
        names: newNames
      };

      return newDataItem;

    case ACDTYPE_IMAGE_ARR:
      return null;
    default:
      throw Error("unknown data type");
  }
}

export function mergeImageArrWith(imageArrItem, anotherItem, reversed) {
  let newStyleType = "";
  let newText = "";
  let newID = "";
  let newDataItem = {};
  let newNames = null;
  let images = [];

  switch (anotherItem.dataType) {
    case ACDTYPE_TEXT:
      throw Error("this order should not happen");
    case ACDTYPE_TEXT_ONLY:
      throw Error("this order should not happen");
    case ACDTYPE_IMAGE:
      throw Error("this order should not happen");
    case ACDTYPE_VIDEO:
      throw Error("this order should not happen");
    case ACDTYPE_AUDIO:
      throw Error("this order should not happen");
    case ACDTYPE_SEPARATOR:
      throw Error("this order should not happen");
    case ACDTYPE_IMAGE_ONLY:
      throw Error("this order should not happen");
    case ACDTYPE_IMAGE_ARR:
      newStyleType = ACSTYPE_GALLERY;
      newText = "";
      newID = generateUniqueID();

      if (!reversed) {
        newStyleType =
          anotherItem.styleType == null ? newStyleType : anotherItem.styleType;
        newStyleType =
          imageArrItem.styleType == null
            ? newStyleType
            : imageArrItem.styleType;
        newText = imageArrItem.text + anotherItem.text;

        newID = anotherItem.id == null ? newID : anotherItem.id;
        newID = imageArrItem.id == null ? newID : imageArrItem.id;

        images = [...imageArrItem.imageItemArr, ...anotherItem.imageItemArr];
      } else {
        newStyleType =
          imageArrItem.styleType == null
            ? newStyleType
            : imageArrItem.styleType;
        newStyleType =
          anotherItem.styleType == null ? newStyleType : anotherItem.styleType;
        newText = anotherItem.text + imageArrItem.text;

        newID = imageArrItem.id == null ? newID : imageArrItem.id;
        newID = anotherItem.id == null ? newID : anotherItem.id;

        images = [...anotherItem.imageItemArr, ...imageArrItem.imageItemArr];
      }

      newDataItem = {
        id: newID,
        text: newText,
        isTextServerProcessed:
          (imageArrItem.textLineIDs == null ||
            anotherItem.textLineIDs == null) &&
          imageArrItem.isTextServerProcessed &&
          anotherItem.isTextServerProcessed,
        textLineIDs: combineTextLineIDs(
          imageArrItem.textLineIDs,
          anotherItem.textLineIDs
        ),
        dataType: ACDTYPE_IMAGE_ARR,
        styleType: newStyleType,
        imageItemArr: images,
        names: newNames
      };

      return newDataItem;
    default:
      throw Error("unknown data type");
  }
}
